import React from 'react';
import { DollarSign, Calendar, Package, ShoppingCart, TrendingUp, Clock, CheckCircle, XCircle, Tag } from 'lucide-react';

const NormalProductsSection = ({ products, handleInvest }) => {
  // Calculate original price (current price + 10%)
  const calculateOriginalPrice = (price) => {
    return Math.round(price / 0.9); // This calculates the pre-discount price
  };

  

  // Calculate savings amount
  const calculateSavings = (price) => {
    return calculateOriginalPrice(price) - price;
  };

  return (
    <div className="normal-products-visiontech-container">
      <div className="normal-products-visiontech-header">
        <h2 className="normal-products-visiontech-title">Investment Packages</h2>
      </div>
      
      <div className="normal-products-visiontech-grid">
        {products.map((product, index) => {
          const originalPrice = calculateOriginalPrice(product.price);
          const savings = calculateSavings(product.price);
          const isAvailable = product.available > 0;
          
          return (
            <div key={index} className={`normal-products-visiontech-card ${!isAvailable ? 'sold-out' : ''}`}>
              <div className="normal-products-visiontech-card-content">
                <div className="normal-products-visiontech-card-top">
                  <div className="normal-products-visiontech-image-container">
                    <img 
                      src={`https://api.visiontech2030.com${product.imageUrl}`}
                      alt={product.name} 
                      className="normal-products-visiontech-image" 
                    />
                    {isAvailable && (
                      <div className="normal-products-visiontech-discount-badge">
                        10% OFF
                      </div>
                    )}
                  </div>
                  
                  <div className="normal-products-visiontech-info">
                    <h3 className="normal-products-visiontech-product-title">{product.name}</h3>
                    
                    <div className="normal-products-visiontech-details">
                      <div className="normal-products-visiontech-detail">
                        <Calendar size={12} className="normal-products-visiontech-icon" />
                        <span>Cycle: <strong>{product.cycle} Days</strong></span>
                      </div>
                      
                      <div className="normal-products-visiontech-detail">
                        <Package size={12} className="normal-products-visiontech-icon" />
                        <span>Available: <strong>{product.available}</strong></span>
                      </div>

                      <div className={`normal-products-visiontech-availability ${isAvailable ? 'available' : 'unavailable'}`}>
                        {isAvailable ? <CheckCircle size={12} /> : <XCircle size={12} />}
                        <span>{isAvailable ? 'In Stock' : 'Out of Stock'}</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="normal-products-visiontech-stats-grid">
                  <div className="normal-products-visiontech-stat">
                    <Tag size={13} className="normal-products-visiontech-stat-icon" />
                    <div className="normal-products-visiontech-stat-content">
                      <p className="normal-products-visiontech-stat-label">Price</p>
                      <div className="normal-products-visiontech-price-display">
                        <span className="normal-products-visiontech-original-price">KES {originalPrice}</span>
                        <h4 className="normal-products-visiontech-current-price">KES {product.price}</h4>
                      </div>
                    </div>
                  </div>
                  
                  <div className="normal-products-visiontech-stat">
                    <Clock size={13} className="normal-products-visiontech-stat-icon" />
                    <div className="normal-products-visiontech-stat-content">
                      <p className="normal-products-visiontech-stat-label">Daily</p>
                      <h4 className="normal-products-visiontech-stat-value">KES {product.dailyIncome}</h4>
                    </div>
                  </div>
                  
                  <div className="normal-products-visiontech-stat">
                    <TrendingUp size={13} className="normal-products-visiontech-stat-icon" />
                    <div className="normal-products-visiontech-stat-content">
                      <p className="normal-products-visiontech-stat-label">Total</p>
                      <h4 className="normal-products-visiontech-stat-value highlight">KES {product.totalIncome}</h4>
                    </div>
                  </div>
                </div>

                <div className="normal-products-visiontech-action">
                  <button 
                    className="normal-products-visiontech-action-button" 
                    onClick={() => handleInvest(product)}
                    disabled={!isAvailable}
                  >
                    <ShoppingCart size={14} className="normal-products-visiontech-button-icon" />
                    <span>{isAvailable ? 'Buy Shares Now' : 'Sold Out'}</span>
                  </button>
                  
                  {isAvailable && (
                    <div className="normal-products-visiontech-savings">
                      Save KES {savings} today!
                    </div>
                  )}
                </div>
              </div>
              
              {!isAvailable && (
                <div className="normal-products-visiontech-sold-out-overlay">
                  <span>Sold Out</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
      
      <style jsx>{`
        .normal-products-visiontech-container {
          padding: 0.1rem;
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .normal-products-visiontech-header {
          text-align: center;
          margin-bottom: 32px;
        }
        
        .normal-products-visiontech-title {
          font-size: 28px;
          font-weight: 700;
          margin: 0 0 8px;
          color: #e2e8f0;
          position: relative;
          display: inline-block;
        }
        
        .normal-products-visiontech-title::after {
          content: '';
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 3px;
          background: linear-gradient(to right, #6366f1, #a5b4fc);
        }
        
        .normal-products-visiontech-subtitle {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          font-size: 16px;
          color: #94a3b8;
        }
        
        .normal-products-visiontech-badge {
          background: linear-gradient(to right, #f59e0b, #fbbf24);
          color: white;
          font-size: 12px;
          font-weight: 600;
          padding: 3px 8px;
          border-radius: 16px;
        }
        
        .normal-products-visiontech-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 20px;
          padding: 0 16px;
        }
        
        .normal-products-visiontech-card {
          background: linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%);
          border-radius: 16px;
          width: 100%;
          max-width: 450px;
          margin-bottom: 0.5rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
          border: 1px solid rgba(120, 113, 255, 0.2);
        }
        
        .normal-products-visiontech-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
          border-color: #475569;
        }
        
        .normal-products-visiontech-card.sold-out {
          opacity: 0.8;
        }
        
        .normal-products-visiontech-card-content {
          padding: 12px;
          flex: 1;
          display: flex;
          flex-direction: column;
          height: 100%;
          position: relative;
        }
        
        .normal-products-visiontech-card-top {
          display: flex;
          gap: 12px;
          margin-bottom: 12px;
        }
        
        .normal-products-visiontech-image-container {
          position: relative;
          width: 70px;
          height: 70px;
          border-radius: 10px;
          overflow: hidden;
          flex-shrink: 0;
          border: 1px solid #475569;
        }
        
        .normal-products-visiontech-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        
        .normal-products-visiontech-image-container:hover .normal-products-visiontech-image {
          transform: scale(1.05);
        }
        
        .normal-products-visiontech-sold-out-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          z-index: 5;
        }
        
        .normal-products-visiontech-discount-badge {
          position: absolute;
          bottom: 0;
          right: 0;
          background: linear-gradient(135deg, #f59e0b, #d97706);
          color: white;
          font-size: 9px;
          font-weight: 700;
          padding: 3px 6px;
          border-radius: 6px 0 0 0;
          box-shadow: 0 2px 8px rgba(251, 191, 36, 0.4);
          animation: pulse 2s infinite;
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        
        .normal-products-visiontech-info {
          flex: 1;
        }
        
        .normal-products-visiontech-product-title {
          font-size: 15px;
          font-weight: 600;
          color: #e2e8f0;
          margin: 0 0 8px;
          line-height: 1.3;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        
        .normal-products-visiontech-details {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        
        .normal-products-visiontech-detail {
          display: flex;
          align-items: center;
          gap: 6px;
          color: #94a3b8;
          font-size: 11px;
        }
        
        .normal-products-visiontech-icon {
          color: #a5b4fc;
        }
        
        .normal-products-visiontech-detail strong {
          color: #cbd5e1;
          font-weight: 600;
        }
        
        .normal-products-visiontech-availability {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 11px;
          margin-top: 2px;
        }
        
        .normal-products-visiontech-availability.available {
          color: #4ade80;
        }
        
        .normal-products-visiontech-availability.unavailable {
          color: #f87171;
        }
        
        .normal-products-visiontech-stats-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 8px;
          margin-bottom: 12px;
          background: rgba(30, 41, 59, 0.5);
          border-radius: 8px;
          padding: 8px;
          border: 1px solid #334155;
        }
        
        .normal-products-visiontech-stat {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }
        
        .normal-products-visiontech-stat-icon {
          color: #a5b4fc;
          margin-bottom: 2px;
        }
        
        .normal-products-visiontech-stat-content {
          width: 100%;
        }
        
        .normal-products-visiontech-stat-label {
          font-size: 10px;
          color: #94a3b8;
          margin: 0 0 2px;
        }
        
        .normal-products-visiontech-price-display {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 2px;
        }
        
        .normal-products-visiontech-original-price {
          font-size: 11px;
          color: #94a3b8;
          text-decoration: line-through;
        }
        
        .normal-products-visiontech-current-price,
        .normal-products-visiontech-stat-value {
          font-size: 12px;
          font-weight: 700;
          color: #e2e8f0;
          margin: 0;
        }
        
        .normal-products-visiontech-stat-value.highlight {
          color: #6366f1;
        }
        
        .normal-products-visiontech-action {
          margin-top: auto;
        }
        
        .normal-products-visiontech-action-button {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: linear-gradient(to right, #6366f1, #818cf8);
          color: white;
          border: none;
          border-radius: 8px;
          padding: 9px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }
        
        .normal-products-visiontech-action-button:disabled {
          background: #334155;
          cursor: not-allowed;
        }
        
        .normal-products-visiontech-action-button:not(:disabled):hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
        }
        
        .normal-products-visiontech-action-button:not(:disabled)::after {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: linear-gradient(
            to right,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          transform: rotate(30deg);
          transition: 0.5s;
          opacity: 0;
          z-index: 1;
        }
        
        .normal-products-visiontech-action-button:not(:disabled):hover::after {
          opacity: 1;
          animation: shine 1.5s forwards;
        }
        
        @keyframes shine {
          0% { transform: translateX(-100%) rotate(30deg); }
          100% { transform: translateX(100%) rotate(30deg); }
        }
        
        .normal-products-visiontech-button-icon {
          position: relative;
          z-index: 2;
        }
        
        .normal-products-visiontech-action-button span {
          position: relative;
          z-index: 2;
        }
        
        .normal-products-visiontech-savings {
          text-align: center;
          font-size: 11px;
          color: #f59e0b;
          font-weight: 600;
          margin-top: 6px;
        }
        
        /* Improved responsive adjustments */
        @media (max-width: 768px) {
          .normal-products-visiontech-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
          }
          
          .normal-products-visiontech-subtitle {
            flex-direction: column;
            gap: 4px;
          }
        }
        
        @media (max-width: 640px) {
          .normal-products-visiontech-grid {
            grid-template-columns: 1fr;
            gap: 16px;
            max-width: 400px;
            margin: 0 auto;
          }
          
          .normal-products-visiontech-title {
            font-size: 24px;
          }
        }
        
        @media (max-width: 480px) {
          .normal-products-visiontech-card-top {
            flex-direction: row;
            gap: 10px;
          }
          
          .normal-products-visiontech-image-container {
            width: 60px;
            height: 60px;
          }
          
          .normal-products-visiontech-product-title {
            font-size: 14px;
          }
          
          .normal-products-visiontech-action-button {
            font-size: 12px;
            padding: 8px;
          }
        }
        
        @media (max-width: 360px) {
          .normal-products-visiontech-stats-grid {
            grid-template-columns: 1fr;
            gap: 6px;
          }
          
          .normal-products-visiontech-stat {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            text-align: left;
          }
          
          .normal-products-visiontech-stat-icon {
            margin-bottom: 0;
          }
          
          .normal-products-visiontech-price-display {
            flex-direction: row;
            align-items: center;
            gap: 6px;
          }
          
          .normal-products-visiontech-original-price {
            order: 2;
          }
          
          .normal-products-visiontech-current-price {
            order: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default NormalProductsSection;
